var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorSpriteBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 253.867,
    height: 277.52,
    viewBox: "0 0 253.867 277.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "color_sprite_bg_1",
    d: "M22459.932,16602.223a12.875,12.875,0,1,1,12.5,9.771A12.879,12.879,0,0,1,22459.932,16602.223Zm60.975-33.346c-28.74-10.912-72.609-15.818-87.785-45.611-15.8-31-24.988-82.947-15.551-114.078,9.773-32.236,39.424-43.262,72.08-59.906,25.336-12.9,45.277-17.492,71.586-13.3,39.221,6.262,82.873,31.513,102.4,69.832,17.646,34.627-28.137,48.584-41.639,82.266-11.146,27.8,14.133,76.924-14.891,91.719-10.766,5.484-20.045,7.652-28.762,7.652C22559.641,16587.453,22543.533,16577.475,22520.906,16568.877Z",
    transform: "translate(-22413.76 -16334.475)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorSpriteBg1);
export default __webpack_public_path__ + "static/media/color_sprite_bg_1.4fcc7e27e93deed38b33805f7052179e.svg";
export { ForwardRef as ReactComponent };